/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticlesResponse } from '../../models/articles-response';
import { KeyType } from '../../models/key-type';

export interface GetDeliveryNoteArticles$Params {
  organizationSiteKey: KeyType;
  deliveryNoteKey: KeyType;
}

export function getDeliveryNoteArticles(http: HttpClient, rootUrl: string, params: GetDeliveryNoteArticles$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticlesResponse>> {
  const rb = new RequestBuilder(rootUrl, getDeliveryNoteArticles.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ArticlesResponse>;
    })
  );
}

getDeliveryNoteArticles.PATH = '/organization-sites/{organizationSiteKey}/delivery-notes/{deliveryNoteKey}/articles';
